import { type ResponseData, useApiQuery } from '@vrplatform/data';
import type { Maybe } from '@vrplatform/utils';

export type PlaidHealthIssue =
  ResponseData<'get:/plaid/health'>['issues'][number];

export const usePlaidHealthQuery = ({
  connectionId,
  appId,
}: {
  connectionId: Maybe<string>;
  appId: Maybe<string>;
}) => {
  'use memo';

  return useApiQuery(
    async (api, signal, args) => {
      if (!args.connectionId)
        return {
          plaid: null,
        };

      const result = await api.GET('/plaid/health', {
        params: {
          query: {
            connectionId: args.connectionId,
          },
        },
        signal,
      });

      if (result.error) throw result.error;

      return {
        plaid: result.data,
      };
    },
    {
      queryGroup: 'accounts',
      uniqueQueryKey: 'plaid-health',
      variables: {
        connectionId,
      },
      skip: !connectionId || appId !== 'plaid',
      hideNotification: true,
      keepPreviousData: true,
    }
  );
};
